import http from 'utils/HttpCommon';
import GenericHttpService from './GenericHttpService';
import { buildUrlSearchParams } from 'utils/utils';
import { identificadorSiconfiFormatter } from 'utils/formatters';
import { forEach } from 'lodash';

const endpoint = 'coc';

const SITUACAO_RASCUNHO = { "id": 590, "codigo": "COC_SITUACAO_RASCUNHO" };

const create = (data) => {
  data = converterPeriodicidade(data);
  return http.post(`/${endpoint}/criar`, data);
}

const update = (id, data) => {
  data = converterPeriodicidade(data);
  return http.put(`/${endpoint}/atualizar/${id}`, data);
}

const endividamentoOCTabela = async ({ codIbge, page, size, sort }) => {
  try {

    let sortParam = sort;

    if (typeof sort === "object" && sort?.sortFields?.length > 0) {
      const { field, dir } = sort.sortFields[0];
      sortParam = `${field},${dir}`;
    }

    const params = new URLSearchParams({
      codIbge,
      page: page - 1,
      size,
      sort: sortParam
    }).toString();

    const response = await http.get(
      `/${endpoint}/endividamento-oc-tabela?${params}`
    );

    return response;

  } catch (error) {
    console.error("Erro ao buscar tabela de endividamento OC:", error);
    return null;
  }
};

const endividamentoOCCronogramaConsolidado = async ({ codIbge }) => {
  try {
    const params = new URLSearchParams({ codIbge }).toString();
    const response = await http.get(
      `/${endpoint}/endividamento-oc-cronograma-consolidado?${params}`
    );
    return response;
  } catch (error) {
    console.error("Erro ao buscar cronograma consolidado de endividamento OC:", error);
    return null;
  }
}

const endividamentoLimitesCronogramaConsolidado = async ({ codIbge }) => {
  try {
    const params = new URLSearchParams({ codIbge }).toString();
    const response = await http.get(
      `/${endpoint}/endividamento-limites-cronograma-consolidado?${params}`
    );
    return response;
  } catch (error) {
    console.error("Erro ao buscar cronograma consolidado dos limites:", error);
    return null;
  }
}


const converterPeriodicidade = (data) => {
  if (data?.tranches?.length > 0) {
    forEach(data.tranches, (tranche) => {
      if (tranche?.periodicidade?.codigo) {
        const { codigo } = tranche.periodicidade;
        tranche.periodicidade = codigo;
      }
    });
  }

  return data;
};

const emptyObject = {
   id: null,
   identificadorSiconfi: null,
   dividaTipo:null,
   dividaDestinacao: '',
   possuiGarantia: null,
   listaSituacoes: [], // Campo para o filtro de situações múltiplas
   devedorInfo: {
    nome: '',
    siglaNatureza: null,
    listaDevedorTipo: [],
    listaTipoEnte: [],
    listaSiglaUF: [],
    listaEnteFederativo: []
   },
   credor:{
     nome: '',
     siglaNatureza: null,
     listaTipoPj:[],
     listaTipoEnte:[],
     listaSiglaUF: [],
     listaEnteFederativo: []
   },
   algumaEtiqueta:[],
   cadaEtiqueta:[],
};

const searchOCByIdSiconfi = async (idSiconfiDivida)=>{
  const searchStr = buildUrlSearchParams({identificadorSiconfi:idSiconfiDivida});
  const response = await GenericHttpService(endpoint).paginatedSearch({searchStr:searchStr,page:0,linesPerPage:1})
  if(response.data.totalElements>0){
    return response.data.content[0];
  }
  else{
      throw new Error(`Identificador Siconfi dívida ${identificadorSiconfiFormatter(idSiconfiDivida) } não localizado`);
  }
}

const obterDadosDevedorUsuarioParticipante = () => {
  return http.get(`/${endpoint}/buscar-dados-devedor-usuario-participante`);
};

const obterDadosCredorUsuarioParticipante = () => {
  return http.get(`/${endpoint}/buscar-dados-credor-usuario-participante`);
};

const buscarCOCPorIDentificadorSicnofiVersaoDTOCompleto = (identificadorSiconfi) => {
  return http.get(`/${endpoint}/buscarPorIdentificadorSiconfi/${identificadorSiconfi}`);
}

export default {
  ...GenericHttpService(endpoint),
  getEmptyObject: () => ({...emptyObject}),
  getByIdSiconfi: (idSiconfi) => {
    return http.get(`/${endpoint}/buscar-por-identificador-siconfi/${idSiconfi}`);
  },
  buscarCOCPorIDentificadorSicnofiVersaoDTOCompleto,
  searchOCByIdSiconfi,
  endividamentoOCList: endividamentoOCTabela,
  endividamentoOCCronogramaConsolidado,
  create,
  update,
  SITUACAO_RASCUNHO,
  obterDadosDevedorUsuarioParticipante,
  obterDadosCredorUsuarioParticipante,
  endividamentoLimitesCronogramaConsolidado,
};